
    import { defineComponent, ref } from 'vue'
    import Disney from '../components/Logos/Disney.vue'
    import Hublot from '../components/Logos/Hublot.vue'
    import Porsche from '../components/Logos/Porsche.vue'
    import Epson from '../components/Logos/Epson.vue'
    import Ikea from '../components/Logos/Ikea.vue'
    import LVMH from '../components/Logos/LVMH.vue'
    import PWC from '../components/Logos/PWC.vue'
    import Vice from '../components/Logos/Vice.vue'
    import Microsoft from '../components/Logos/Microsoft.vue'
    import Nike from '../components/Logos/Nike.vue'
    import UBS from '../components/Logos/UBS.vue'
    import EF from '../components/Logos/EF.vue'
    import Agoda from '../components/Logos/Agoda.vue'
    import Lenovo from '../components/Logos/Lenovo.vue'
    import Kaspersky from '../components/Logos/Kaspersky.vue'
    import { usePartnerLogoAnimation } from '../compositions/UsePartnerLogoAnimation'
    import { VueInstance } from '../Interfaces/VueInstance'

    export default defineComponent({
        name: 'PartnersNew',
        setup() {

            const logos: VueInstance[] = [
                Microsoft,
                Hublot,
                Nike,
                Ikea,
                Kaspersky,
                UBS,
                Disney,
                Porsche,
                Lenovo,
                PWC,

                Vice,
                Epson,
                Agoda,
                LVMH,
                EF
            ]

            const numberOfVisibleLogos = ref(10)
            const { activeLogos, hooks } = usePartnerLogoAnimation(logos, numberOfVisibleLogos)

            const beforeEnter = (element: SVGElement) => {

                const groups = element.querySelectorAll('g')
                groups.forEach(g => {

                    g.classList.remove('show', 'hide')

                })

            }

            const afterLeave = (element: SVGElement) => {

                const groups = element.querySelectorAll('g')
                groups.forEach(g => {

                    g.classList.remove('show', 'hide')

                })

            }

            return {
                activeLogos,
                hooks: {
                    ...hooks,
                    beforeEnter,
                    afterLeave
                }
            }

        }
    })
